const DAY_MS = 86_400_000;

/** 그 시각이 속한 날의 자정(기기 시간대). */
const startOfDay = (ms: number): number => {
  const date = new Date(ms);
  date.setHours(0, 0, 0, 0);
  return date.getTime();
};

/**
 * "함께한 지 N일째" 의 N — 초기 설정을 마친 **날**이 1일째이고, 자정을 넘길 때마다 는다.
 * 24시간 굴림이 아니다: 밤 11시에 시작한 사람도 다음 날 아침에는 2일째다.
 *
 * 가입일 필드는 없다. `Profile.completedAt`(설정을 마친 시각)이 가장 가까운 값이고, 설정
 * 밖에서 만들어진 프로필은 그 값이 0 이다. 0 이거나 기기 시계가 그보다 과거면 셀 수 없으니
 * `null` — 화면은 그 줄을 비운다.
 */
export const daysTogether = (
  completedAt: number,
  now: number,
): number | null =>
  completedAt > 0 && now >= completedAt
    ? // 서머타임으로 하루가 23·25시간인 날이 있어 반올림한다.
      Math.round((startOfDay(now) - startOfDay(completedAt)) / DAY_MS) + 1
    : null;
